/**
 * api-error-text.ts — Chọn câu thông báo lỗi từ thân phản hồi của backend (hàm thuần, không phụ thuộc axios).
 *
 * Backend có hai dạng thân lỗi:
 *  - Route tự trả: `{ error: "<câu tiếng Việt>", code }` → câu hiển thị nằm ở `error`.
 *  - Lỗi mặc định của Fastify (reply.unauthorized(...), throw httpErrors…):
 *    `{ statusCode: 401, error: "Unauthorized", message: "Email hoặc mật khẩu không đúng" }` → `error` chỉ là TÊN MÃ HTTP
 *    bằng tiếng Anh, câu thật nằm ở `message`.
 * Lấy `error` trước một cách máy móc sẽ hiện "Unauthorized" cho khách; nên bỏ qua `error` khi nó chỉ là tên mã HTTP.
 */

/** Tên mã HTTP chuẩn (chữ thường) mà Fastify/`http-errors` điền vào trường `error`. */
const HTTP_REASON_NAMES = new Set([
  'bad request', 'unauthorized', 'payment required', 'forbidden', 'not found', 'method not allowed', 'not acceptable',
  'proxy authentication required', 'request timeout', 'conflict', 'gone', 'length required', 'precondition failed',
  'payload too large', 'uri too long', 'unsupported media type', 'range not satisfiable', 'expectation failed',
  'misdirected request', 'unprocessable entity', 'locked', 'failed dependency', 'too early', 'upgrade required',
  'precondition required', 'too many requests', 'request header fields too large', 'unavailable for legal reasons',
  'internal server error', 'not implemented', 'bad gateway', 'service unavailable', 'gateway timeout',
  'http version not supported',
])

/** `error` chỉ là tên mã HTTP chung (vd "Unauthorized", "Bad Request") chứ không phải câu để hiện cho người dùng. */
export function isGenericHttpErrorName(value: unknown): boolean {
  return typeof value === 'string' && HTTP_REASON_NAMES.has(value.trim().toLowerCase())
}

/**
 * Câu thông báo từ thân phản hồi lỗi: `error` nếu là câu thật; `error` chỉ là tên mã HTTP → dùng `message`.
 * Không có câu nào dùng được → undefined (nơi gọi tự chọn câu dự phòng).
 */
export function apiErrorText(body: unknown): string | undefined {
  const b = body as { error?: unknown; message?: unknown } | null | undefined
  const error = typeof b?.error === 'string' ? b.error.trim() : ''
  if (error && !isGenericHttpErrorName(error)) return error
  const message = typeof b?.message === 'string' ? b.message.trim() : ''
  return message || undefined
}
